import { css } from 'styled-components';

export default css`
  fill: currentColor;
  vertical-align: middle;
  width: 1em;
  height: 1em;
  font-size: 24px
`;
